export default "__VITE_ASSET__CPCC58PO__"